<!--
 * @Author: your name
 * @Date: 2021-11-05 13:47:38
 * @LastEditTime: 2023-10-23 17:18:15
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\components\BjInputMobile\index.vue
-->
<template>
  <div ref="BjSelectSqlLov">
    <el-input
      v-model="valueName"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder || $t('chooseText')"
      :size="size"
      :clearable="clearable"
      :style="'width:' + width"
    >
      <div slot="append">
        <!-- <i class="el-icon-circle-close"></i> -->
        <el-button
          v-if="valueName && clearable"
          :disabled="disabled"
          icon="el-icon-circle-close"
          @click="clear"
        ></el-button>
        <el-button :disabled="disabled" icon="el-icon-search" @click="showDialog"></el-button>
      </div>
    </el-input>
    <BjDialogList
      v-if="lovView.viewCode"
      ref="dialogList"
      :is-list="cptIsList"
      :config="dialogListConfig"
      :disabled="disabledIds"
      :multiple="multiple"
      :row-key="cptRowKey"
      :tag-name="cptTagName"
      @confirm="onConfirmDialogList"
    />
  </div>
</template>
<script>
import { baseDataApi } from '@/api';

export default {
  name: 'BjSelectSqlLov',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'mini',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabledIds: {
      type: Array,
      default: function () {
        return [];
      },
    },
    label: {
      type: String,
      default: '',
    },
    lovCode: {
      type: String,
      default: 'HPFM.COUNTRY',
    },
    rowKey: {
      type: String,
      default: 'countryId',
    },
    tagName: {
      type: String,
      default: 'countryName',
    },
    title: {
      type: String,
      default: '选择国家',
    },
    columns: {
      type: Array,
      default: function () {
        return [
          {
            prop: 'countryCode',
            label: '国家编码',
          },
          {
            prop: 'countryName',
            label: '国家名称',
          },
        ];
      },
    },
    search: {
      type: Array,
      default: function () {
        return [
          {
            placeholder: '请输入国家编码/国家名称',
            key: 'condition',
          },
        ];
      },
    },
    defaultQuery: {
      type: Object,
      default: function () {
        return {
          // enabledFlag: 1,
        };
      },
    },
    actionApi: Function,
    getViewCode: {
      type: Function,
      default: baseDataApi.getLovView,
    },
  },
  data() {
    return {
      id: null,
      valueName: null,
      lovView: {
        viewCode: '',
        lovCode: 'HADM.SERVICE_ROUTE',
        lovTypeCode: 'SQL',
        tenantId: 0,
        valueField: 'serviceRouteId',
        displayField: 'path',
        pageSize: 10,
        delayLoadFlag: 0,
        queryUrl: '/sadm/v1/lovs/sql/data',
        queryFields: [
          // {
          //   field: 'serviceRouteId',
          //   label: '路由ID',
          //   dataType: null,
          //   sourceCode: null,
          // },
        ],
        tableFields: [
          // {
          //   title: '路由ID',
          //   dataIndex: 'serviceRouteId',
          //   width: 200,
          // },
        ],
      },
    };
  },
  computed: {
    cptTagName() {
      return this.lovView.displayField || this.tagName;
    },
    cptRowKey() {
      return this.lovView.valueField || this.rowKey;
    },
    dialogListConfig() {
      const title = this.title || '';
      const actionApi = this.actionApi || baseDataApi.getLovSqlData;
      const lovCode = this.lovView.lovCode || this.lovCode;
      // const tenantId = this.lovView.tenantId || this.$store.getters.tenantId;
      const BjUrl = this.lovView.queryUrl || false;
      let columns = [...this.columns];
      if (this.lovView.tableFields && this.lovView.tableFields.length) {
        columns = this.lovView.tableFields.map(e => ({ prop: e.dataIndex, label: e.title }));
      }
      let search = [...this.search];
      if (this.lovView.queryFields && this.lovView.queryFields.length) {
        search = this.lovView.queryFields.map(e => ({ key: e.field, placeholder: e.label }));
      }
      console.log({
        title,
        columns,
        search,
        actionApi,
        defaultQuery: {
          lovCode,
          BjUrl,
          ...this.defaultQuery,
        },
        query: '',
      });
      console.log(this.defaultQuery);
      return {
        title,
        columns,
        search,
        actionApi,
        defaultQuery: {
          lovCode,
          BjUrl,
          ...this.defaultQuery,
        },
        query: '',
      };
    },
    cptIsList() {
      return this.lovTypeCode ? this.lovTypeCode === 'URL' : this.isList;
    },
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
        if (!v && v !== 0) {
          this.valueName = null;
        }
      },
      immediate: true,
    },
    label: {
      handler(v) {
        this.valueName = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
      this.$emit('change', v);

      try {
        this.$refs.BjSelectSqlLov.__vue__.$parent.$emit('el.form.blur');
        this.$refs.BjSelectSqlLov.__vue__.$parent.$emit('el.form.change');
        //  //非el的输入组件，值变化时不会触发el-from-item的重新校验，需要手动触发el.form.change事件
        // this.$refs.BjSelectSqlLov.$parent.$parent.$emit('el.form.change');
      } catch (error) {
        console.warn(error);
      }
    },
  },
  created() {},
  methods: {
    getInfo() {
      return new Promise((resolve, reject) => {
        this.getViewCode({ viewCode: this.lovCode }).then(res => {
          Object.keys(res).forEach(key => {
            this.$set(this.lovView, key, res[key]);
          });
          resolve(res);
        });
      });
    },
    clear() {
      this.id = null;
      this.valueName = null;
    },
    async showDialog() {
      await this.getInfo();
      this.$nextTick(() => {
        this.$refs.dialogList.show();
      });
    },
    onConfirmDialogList(data) {
      console.log(data);
      if (Array.isArray(data) && data.length) {
        if (this.multiple) {
          this.id = data.map(e => e[this.cptRowKey]);
          this.valueName = data.map(e => e[this.cptTagName]).join();
          this.$emit('confirm', data);
        } else {
          this.id = data[0][this.cptRowKey];
          this.valueName = data[0][this.cptTagName];
          this.$emit('confirm', data[0]);
        }
      }
    },
  },
};
</script>
